import React, { useEffect, useState } from "react"
import { SaveButton } from "components/Buttons"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import EditContactModal from "./editContactModal"
import ViewContactModal from "./viewContactModal"
import {
  getCustomers,
  resetUserMetaTags,
  setSelectedCustomer,
  updateCustomerData,
} from "store/actions"
import { getFormSyncErrors, getFormValues } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { mapEditContactFormToApi } from "./utils"

const ViewModal = ({
  selectedCustomer,
  setSelectedCustomer,
  resetUserMetaTags,
  onClose,
  formValues,
  updateCustomerData,
  vendorId,
  loading,
  formSyncErrors,
  callbackParams,
  getCustomers,
}) => {
  const [toggleViewContact, setToggleViewContact] = useState(false)

  useEffect(() => {
    return () => {
      setSelectedCustomer(null)
      resetUserMetaTags()
    }
  }, [])

  const handleEditContact = values => {
    if (
      (formSyncErrors && Object.keys(formSyncErrors).length === 0) ||
      !formSyncErrors
    ) {
      updateCustomerData({
        userId: selectedCustomer?.id,
        customerData: mapEditContactFormToApi(values),
        tags: {
          tags: values?.tags,
          user_id: selectedCustomer?.id,
          vendor_id: vendorId,
        },
        callback: () => {
          setToggleViewContact(!toggleViewContact)
          getCustomers({ ...callbackParams })
        },
      })
    }
  }

  return (
    <React.Fragment>
      <Row className="p-2" style={{ backgroundColor: "#e8e8e8" }}>
        <Col className="align-self-center ms-1">
          <h5>{selectedCustomer?.display_name}</h5>
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content={toggleViewContact ? "Save" : "Edit"}
            loading={toggleViewContact ? loading : null}
            onClick={
              toggleViewContact
                ? () => {
                    handleEditContact(formValues)
                  }
                : () => setToggleViewContact(!toggleViewContact)
            }
          />
        </Col>
        <Col xs="auto" className="align-self-center ps-0">
          <i
            className="bx bx-sm bx-x"
            onClick={onClose}
            style={{ cursor: "pointer" }}
          />
        </Col>
      </Row>
      {toggleViewContact ? (
        <EditContactModal
          contact={selectedCustomer}
          onSubmit={values => {
            handleEditContact(values)
          }}
        />
      ) : (
        <ViewContactModal contact={selectedCustomer} />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  selectedCustomer: state.people.selectedCustomer,
  formValues: getFormValues(FORM_NAMES.EDIT_CONTACT)(state),
  vendorId: state.Login.vendorId,
  loading: state.people.loading,
  formSyncErrors: getFormSyncErrors(FORM_NAMES.EDIT_CONTACT)(state),
})

const mapDispatchToProps = dispatch => ({
  setSelectedCustomer: values => dispatch(setSelectedCustomer(values)),
  resetUserMetaTags: () => dispatch(resetUserMetaTags()),
  updateCustomerData: values => dispatch(updateCustomerData(values)),
  getCustomers: values => dispatch(getCustomers(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewModal)
